import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { AutoCompleteGeneric } from "src/Pages/components/InputAutoCompleted/AutoCompleteGeneric";
import { IPropsAutoCompleted } from "src/Pages/components/InputAutoCompleted/types";

export const AutoCompletePerfisGeneric = (props: IPropsAutoCompleted) => {
  const {
    disabled,
    label,
    width,
    tamanho,
    minWidth,
    maxWidth,
    fullWidth,
    tooltip,
    variant,
  } = props;
  const { setValueAutoCompPerfilAcesso, valueAutoCompPerfilAcesso } =
    UseAutoCompletedAll();

  return (
    <AutoCompleteGeneric
      disabled={disabled}
      fullWidth={fullWidth}
      label={label}
      maxWidth={maxWidth}
      minWidth={minWidth}
      setValueAutoCompleted={setValueAutoCompPerfilAcesso}
      tamanho={tamanho}
      tooltip={tooltip}
      url="/GetAllPerfils"
      valueAutoCompleted={valueAutoCompPerfilAcesso}
      variant={variant}
      width={width}
    />
  );
};
